<ng-container *ngIf="state.state$ | async as draft">
    <section class="step step-basics">
        <header class="step-header">
            <h2>Tell us about your organization</h2>
            <p class="lede">You can change these any time from organization settings.</p>
        </header>

        <div class="form">
            <mat-form-field appearance="outline" class="full">
                <mat-label>Organization name</mat-label>
                <input
                    matInput
                    type="text"
                    [value]="draft.basics.name"
                    (input)="updateName($any($event.target).value)"
                    placeholder="Acme Components"
                    maxlength="120"
                    autocomplete="off"
                />
                <mat-hint align="end">{{ draft.basics.name.length }}/120</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full">
                <mat-label>Description (optional)</mat-label>
                <textarea
                    matInput
                    rows="3"
                    [value]="draft.basics.description"
                    (input)="updateDescription($any($event.target).value)"
                    placeholder="What does this organization do?"
                    maxlength="500"
                ></textarea>
                <mat-hint align="end">{{ draft.basics.description.length }}/500</mat-hint>
            </mat-form-field>
        </div>

        <p class="footnote">
            Working hours, day-of-month boundaries and other settings will be filled in with sensible defaults
            (Mon–Fri, 8 hours/day, calendar month). You can refine them from the organization settings screen
            once the org is created.
        </p>
    </section>
</ng-container>
